.cy-toast-container {
    position: fixed;
    left: 16px;
    bottom: 16px;
    /* Portalizado a <body> (sibling de #root, que no crea stacking context): un dígito basta
       para quedar sobre el contenido de la app. Los toasts van encima de todo, así que toman
       el dígito más alto de la escala. La normalización de los z-index inflados del resto del
       proyecto (celda_*, modales, WhatsPanel...) es la fase 50 de tech-debt. */
    z-index: 999999;
    display: flex;
    flex-direction: column-reverse;
    gap: 8px;
    pointer-events: none;
    max-width: 360px;
}

.cy-toast {
    pointer-events: auto;
    display: flex;
    align-items: center;
    gap: 10px;
    background: var(--bg-panel-darker, #1C1C1C);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-left: 3px solid var(--color-accent, #95E248);
    border-radius: 14px;
    padding: 12px 14px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
    animation: cy-toast-in 250ms ease-out;
}

.cy-toast-error {
    border-left-color: #ef4444;
}

.cy-toast-pulse {
    flex: none;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--color-accent, #95E248);
    box-shadow: 0 0 0 0 rgba(149, 226, 72, 0.5);
    animation: cy-toast-pulse-ring 1.8s ease-out infinite;
}

.cy-toast-error .cy-toast-pulse {
    background: #ef4444;
    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.5);
    animation-name: cy-toast-pulse-ring-error;
}

.cy-toast-message {
    color: var(--text-primary, #FFFFFF);
    font-size: 13px;
    line-height: 1.4;
    flex: 1;
}

.cy-toast-tag {
    flex: none;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.03em;
    color: #000;
    padding: 2px 6px;
    border-radius: 6px;
}

.cy-toast-close {
    flex: none;
    background: transparent;
    border: none;
    color: var(--text-secondary, #6E6E6E);
    font-size: 16px;
    line-height: 1;
    cursor: pointer;
    padding: 2px 4px;
}

.cy-toast-close:hover {
    color: var(--text-primary, #FFFFFF);
}

@keyframes cy-toast-in {
    from {
        opacity: 0;
        transform: translateY(6px) scale(0.96);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes cy-toast-pulse-ring {
    0% { box-shadow: 0 0 0 0 rgba(149, 226, 72, 0.5); }
    70% { box-shadow: 0 0 0 6px rgba(149, 226, 72, 0); }
    100% { box-shadow: 0 0 0 0 rgba(149, 226, 72, 0); }
}

@keyframes cy-toast-pulse-ring-error {
    0% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.5); }
    70% { box-shadow: 0 0 0 6px rgba(239, 68, 68, 0); }
    100% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0); }
}
